import { render, staticRenderFns } from "./VmList.vue?vue&type=template&id=1c412baa&scoped=true&"
import script from "./VmList.vue?vue&type=script&lang=js&"
export * from "./VmList.vue?vue&type=script&lang=js&"
import style0 from "./VmList.vue?vue&type=style&index=0&id=1c412baa&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c412baa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCard,VCardText,VContainer,VDataTable,VDialog,VSnackbar})
